import Placeholder from '../../assets/images/placeholder.jpg';

export const initialState = {
  watchData: null,
  businessData: [],
  association: false,
  generatedCode: '',
  loading: true,
  error: false,
  status: null,
  correlation: null,
  productImgUrl: Placeholder,
};

export function reducer(state, action) {
  switch (action.type) {
    case 'SET_REQUEST_METADATA':
      return {
        ...state,
        status:
          action.payload.status !== undefined
            ? action.payload.status
            : state.status,
        correlation:
          action.payload.correlation !== undefined
            ? action.payload.correlation
            : state.correlation,
      };

    case 'SET_WATCH_DATA':
      return {
        ...state,
        watchData: action.payload,
      };

    case 'SET_BUSINESS_DATA':
      return {
        ...state,
        businessData: action.payload,
      };

    case 'SET_PRODUCT_IMAGE': {
      if (state.productImgUrl === action.payload) {
        return state;
      }

      return {
        ...state,
        productImgUrl: action.payload,
      };
    }

    case 'SET_ASSOCIATION':
      return {
        ...state,
        association: true,
        generatedCode: action.payload,
      };

    case 'FINISH_LOADING':
      return {
        ...state,
        loading: false,
      };

    case 'FAIL':
      return {
        ...state,
        error: true,
        loading: false,
        status:
          action.payload.status !== undefined
            ? action.payload.status
            : state.status,
        correlation:
          action.payload.correlation !== undefined
            ? action.payload.correlation
            : state.correlation,
      };

    default:
      return state;
  }
}
